import { render, staticRenderFns } from "./CarpassObservationDescriptionTireEdit.vue?vue&type=template&id=59b204a7"
import script from "./CarpassObservationDescriptionTireEdit.vue?vue&type=script&lang=ts"
export * from "./CarpassObservationDescriptionTireEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59b204a7')) {
      api.createRecord('59b204a7', component.options)
    } else {
      api.reload('59b204a7', component.options)
    }
    module.hot.accept("./CarpassObservationDescriptionTireEdit.vue?vue&type=template&id=59b204a7", function () {
      api.rerender('59b204a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cars/CarpassObservationDescriptionTireEdit.vue"
export default component.exports